// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { scroller, Element, Events } from "react-scroll";
// import {
//     AppBar,
//     Toolbar,
//     Typography,
//     Button,
//     IconButton,
//     Box,
//     Drawer,
//     List,
//     ListItem,
//     ListItemText,
//     ListItemIcon,
//     useMediaQuery,
//     Grid
// } from "@mui/material";
// import { Link } from "react-scroll";
// import MenuIcon from "@mui/icons-material/Menu";
// import SearchIcon from "@mui/icons-material/Search";
// import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import HomeIcon from "@mui/icons-material/Home";
// import SchoolIcon from "@mui/icons-material/School";
// import ListAltIcon from "@mui/icons-material/ListAlt";
// import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
// import PeopleIcon from "@mui/icons-material/People";
// import ArticleIcon from "@mui/icons-material/Article";
// import logo from "../assets/logo.png";
// import footerlogo from "../assets/aakash-logo-footer.png";
// import AutoPopUp from "../componant/AutoPopUp";

// const Header = () => {
//     const [mobileOpen, setMobileOpen] = useState(false);
//     const isMobile = useMediaQuery("(max-width: 900px)");
//     const [openPopup, setOpenPopup] = useState(false);
//     const location = useLocation();
//     const navigate = useNavigate();

//     const handleClosePopup = () => {
//         setOpenPopup(false);
//     };

//     const handleDrawerToggle = () => {
//         setMobileOpen(!mobileOpen);
//     };

//     // Navigation Links
//     const navLinks = [
//         { text: "Home", icon: <HomeIcon />, id: "banner" },
//         { text: "Our Centers", icon: <LocationOnIcon />, id: "our-centers" },
//         { text: "Courses", icon: <SchoolIcon />, id: "popular-courses" },
//         { text: "Results", icon: <ListAltIcon />, id: "outstanding-results" },
//         { text: "JEE Rank Predictor 2025", icon: <EmojiObjectsIcon />, id: "jee-rank" },
//         { text: "Student's Hub", icon: <PeopleIcon />, id: "student-hub" },
//         { text: "Blog", icon: <ArticleIcon />, id: "blog" }
//     ];

//     // Function to update the URL without reloading
//     const updateUrl = (id) => {
//         if (window.history.pushState) {
//             window.history.pushState(null, "", `#${id}`);
//         }
//     };

//     // Scroll to section if URL has a hash (e.g., #courses)
//     useEffect(() => {
//         if (location.hash) {
//             const section = location.hash.replace("#", "");
//             scroller.scrollTo(section, { smooth: true, duration: 500, offset: -70 });
//         }
//     }, [location.hash]);

//     return (
//         <AppBar position="fixed" sx={{ backgroundColor: "#00AEEF", height: '60px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
//             <Toolbar sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
//                 {isMobile ? (
//                     <>
//                         {/* Left Side - Hamburger Menu */}
//                         <IconButton edge="start" color="inherit" onClick={handleDrawerToggle}>
//                             <MenuIcon />
//                         </IconButton>

//                         {/* Center - Logo */}
//                         <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
//                             <img src={footerlogo} alt="logo" style={{ width: '80px', height: '60px' }} />
//                         </Box>

//                         {/* Right Side - Icons */}
//                         <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                             <IconButton sx={{ color: "white" }}>
//                                 <SearchIcon />
//                             </IconButton>
//                             <a href="tel:9901499299" style={{ textDecoration: "none", color: "inherit" }}>
//                                 <IconButton sx={{ color: "white" }}>
//                                     <PhoneRoundedIcon />
//                                 </IconButton>
//                             </a>
//                         </Box>
//                     </>
//                 ) : (
//                     <Grid container sx={{ display: "flex", alignItems: "center" }}>
//                         {/* Centered Button */}
//                         <Grid item sx={{ flexGrow: 1, display: "flex", justifyContent: "center", ml: 25 }}>
//                             <Button
//                                 variant="outlined"
//                                 size="small"
//                                 sx={{ color: "#fff", fontWeight: "bold", borderColor: "#fff", fontSize: 12 }}
//                                 onClick={() => setOpenPopup(true)} // Open modal on click
//                             >
//                                 Admission open 2026-27
//                             </Button>
//                         </Grid>

//                         {/* Right-aligned Content */}
//                         <Grid item sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 2 }}>
//                             <PhoneRoundedIcon sx={{ fontSize: 19 }} />
//                             <Typography
//                                 variant="body1"
//                                 component="a"
//                                 href="tel:9901499299"
//                                 sx={{ fontSize: 15, fontWeight: 'bold', ml: -1, cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
//                             >
//                                  9741749363
//                             </Typography>
//                             <LocationOnIcon />
//                             <Typography
//                                 variant="body1"
//                                 sx={{ cursor: "pointer", fontSize: 15, fontWeight: 'bold', ml: -1 }}
//                             >
//                                 Yelahanka
//                             </Typography>
//                         </Grid>
//                     </Grid>
//                 )}
//             </Toolbar>

//             {/* Navigation Menu (Desktop) */}
//             {!isMobile && (
//                 <Toolbar sx={{ display: "flex", justifyContent: "space-between", backgroundColor: "white", color: "black", mt: -1, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
//                     <img src={logo} alt="logo" style={{ width: '80px', height: '50px', marginLeft: 25 }} />
//                     <Box sx={{ display: "flex", gap: 3 }}>
//                         {navLinks.map(({ text, id }) => (
//                             <Link 
//                                 key={id} 
//                                 to={id} 
//                                 smooth={true} 
//                                 duration={500} 
//                                 spy={true} 
//                                 offset={-70} 
//                                 style={{ textDecoration: "none", cursor: "pointer", fontWeight: "bold" }}
//                                 onClick={() => updateUrl(id)}
//                             >
//                                 <Typography variant="body1">{text}</Typography>
//                             </Link>
//                         ))}
//                     </Box>
//                 </Toolbar>
//             )}

//             {/* Mobile Drawer */}
//             <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
//                 <Box sx={{ width: 250 }}>
//                     <List>
//                         {navLinks.map(({ text, icon, id }) => (
//                             <ListItem button key={id} onClick={() => { handleDrawerToggle(); updateUrl(id); }}>
//                                 <ListItemIcon>{icon}</ListItemIcon>
//                                 <Link to={id} smooth={true} duration={500} spy={true} offset={-70} style={{ textDecoration: "none", color: "black" }}>
//                                     <ListItemText primary={text} />
//                                 </Link>
//                             </ListItem>
//                         ))}
//                     </List>
//                 </Box>
//             </Drawer>
//             <AutoPopUp isOpen={openPopup} onClose={handleClosePopup} />
//         </AppBar>
//     );
// };

// export default Header;

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scroller, Events } from "react-scroll";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";

import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    IconButton,
    Box,
    Drawer,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    useMediaQuery,
    Grid
} from "@mui/material";
import { Link } from "react-scroll";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeIcon from "@mui/icons-material/Home";
import SchoolIcon from "@mui/icons-material/School";
import ListAltIcon from "@mui/icons-material/ListAlt";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import PeopleIcon from "@mui/icons-material/People";
import ArticleIcon from "@mui/icons-material/Article";
import logo from "../assets/logo.png";
import footerlogo from "../assets/aakash-logo-footer.png";
import AutoPopUp from "../componant/AutoPopUp";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const isMobile = useMediaQuery("(max-width: 900px)");
    const [openPopup, setOpenPopup] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();


    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const navLinks = [
        { text: "Home", icon: <HomeIcon />,  route: "/", id: "home" },
        { text: "Neet Repeater", icon: <HomeIcon />, route: "/course-details", highlight: true },
        { text: "Engineering Repeater", icon: <HomeIcon />, route: "/repeater-engg", highlight: true },
        { text: "Apply Scholarship", icon: <HomeIcon />, route: "/apply-scholarship", highlight: true },
        // { text: "Apply for ANTHE", icon: <SchoolIcon />, route: "/anthe", highlight: true, anthe: true },
        { text: "Offers", icon: <HomeIcon />, route: "/offers", highlight: true },
        // { text: "Our Centers", icon: <LocationOnIcon />, hasDropdown: true, id: "our-centers" },
        { text: "Courses", icon: <SchoolIcon />, id: "popular-courses" },
        { text: "Results", icon: <ListAltIcon />, id: "outstanding-results" },
        { text: "JEE Rank Predictor 2025", icon: <EmojiObjectsIcon />, id: "jee-rank" },
        { text: "Student's Hub", icon: <PeopleIcon />, hasDropdown: true, id: "student-hub" },
        { text: "Blog", icon: <ArticleIcon />, id: "blog" }
    ];

    // Function to update the URL dynamically without reloading
    const updateUrl = (id) => {
        if (window.history.pushState) {
            window.history.pushState(null, "", `#${id}`);
        }
    };

    // Scroll to section if URL has a hash (e.g., #courses)
    useEffect(() => {
        if (location.hash) {
            const section = location.hash.replace("#", "");
            scroller.scrollTo(section, { smooth: true, duration: 500, offset: -70 });
        }
    }, [location.hash]);

    return (
        <AppBar position="fixed" sx={{ backgroundColor: "#00AEEF", height: '60px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
            <Toolbar sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                {isMobile ? (
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                        {/* Left - Menu Icon */}
                        <IconButton edge="start" color="inherit" onClick={handleDrawerToggle}>
                            <MenuIcon />
                        </IconButton>

                        {/* Center - Logo */}
                        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
                            <RouterLink to="/" style={{ display: "inline-block" }}>
                                <img src={footerlogo} alt="logo" style={{ width: '80px', height: '60px' }} />
                            </RouterLink>
                        </Box>

                        {/* Right - Icons */}
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <IconButton sx={{ color: "white" }}>
                                <SearchIcon />
                            </IconButton>
                            <a href="tel:+91 7026505152" style={{ textDecoration: "none", color: "inherit" }}>
                                <IconButton sx={{ color: "white" }}>
                                    <PhoneRoundedIcon />
                                </IconButton>
                            </a>
                        </Box>
                    </Box>
                ) : (
                    <Grid container sx={{ display: "flex", alignItems: "center" }}>
                        {/* Centered Button */}
                        <Grid item sx={{ flexGrow: 1, display: "flex", justifyContent: "center", ml: 25 }}>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{ color: "#fff", fontWeight: "bold", borderColor: "#fff", fontSize: 12 }}
                                onClick={() => setOpenPopup(true)}
                            >
                                Admission open 2026-27
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{ color: "#fff", fontWeight: "bold", borderColor: "#fff", fontSize: 12, ml: 2 }}
                                onClick={() => navigate("/anthe")}
                            >
                                Apply for ANTHE
                            </Button>
                        </Grid>

                        {/* Right-aligned Content */}
                        <Grid item sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 2 }}>
                            <PhoneRoundedIcon sx={{ fontSize: 19 }} />
                            <Typography
                                variant="body1"
                                component="a"
                                href="tel:+91 7026505152"
                                sx={{ fontSize: 15, fontWeight: 'bold', ml: -1, cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
                            >
                                +91 7026505152
                            </Typography>
                            <LocationOnIcon />
                            <Typography
                                variant="body1"
                                sx={{ cursor: "pointer", fontSize: 15, fontWeight: 'bold', ml: -1 }}
                            >
                                Yelahanka
                            </Typography>
                        </Grid>

                    </Grid>
                )}
            </Toolbar>

            {/* Navigation Menu (Desktop) */}
            {!isMobile && (
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", backgroundColor: "white", color: "black", mt: -1, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
                    <RouterLink to="/" style={{ display: "inline-block", marginLeft: 25 }}>
                        <img src={logo} alt="logo" style={{ width: '80px', height: '50px' }} />
                    </RouterLink>
                    <Box sx={{ display: "flex", gap: 3 }}>
                        {navLinks.map(({ text, id, route, highlight, anthe }) => {
                            if (route) {
                                if (anthe) {
                                    return (
                                        <Button
                                            key={text}
                                            component={RouterLink}
                                            to={route}
                                            variant="contained"
                                            sx={{
                                                background: "linear-gradient(135deg, #FFD700, #FFA000)",
                                                color: "#003087",
                                                fontWeight: 800,
                                                fontSize: 12,
                                                px: 2,
                                                py: 0.6,
                                                borderRadius: 2,
                                                textTransform: "none",
                                                boxShadow: "0 2px 8px rgba(255,160,0,0.4)",
                                                "&:hover": {
                                                    background: "linear-gradient(135deg, #FFC107, #FF8F00)",
                                                    transform: "scale(1.04)",
                                                    boxShadow: "0 4px 14px rgba(255,160,0,0.5)",
                                                },
                                                transition: "all 0.2s",
                                                animation: "pulse 2s infinite",
                                                "@keyframes pulse": {
                                                    "0%": { boxShadow: "0 2px 8px rgba(255,160,0,0.4)" },
                                                    "50%": { boxShadow: "0 4px 18px rgba(255,160,0,0.7)" },
                                                    "100%": { boxShadow: "0 2px 8px rgba(255,160,0,0.4)" },
                                                },
                                            }}
                                        >
                                            🎓 Apply for ANTHE
                                        </Button>
                                    );
                                }
                                return (
                                    <Button
                                        key={text}
                                        component={RouterLink}
                                        to={route}
                                        sx={{
                                            cursor: "pointer",
                                            fontWeight: "bold",
                                            color: highlight ? "#FF5722" : "inherit",
                                            textDecoration: highlight ? "underline" : "none",
                                            minWidth: "auto",
                                            padding: 0,
                                            textTransform: "none"
                                        }}
                                    >
                                        {text}
                                    </Button>
                                );
                            }

                            if (id) {
                                return (
                                    <ScrollLink
                                        key={id}
                                        to={id}
                                        smooth={true}
                                        duration={500}
                                        offset={-70}
                                        style={{ textDecoration: "none", cursor: "pointer" }}
                                    >
                                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                            {text}
                                        </Typography>
                                    </ScrollLink>
                                );
                            }

                            return null;
                        })}
                    </Box>

                </Toolbar>
            )}

            {/* Mobile Drawer */}
            <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
                <Box sx={{ width: 250 }}>
                    <List sx={{cursor:'pointer'}}>
                        {navLinks.map(({ text, icon, id, route, anthe }) => {
                            if (route) {
                                return (
                                    <ListItem
                                        button
                                        key={text}
                                        onClick={() => {
                                            handleDrawerToggle();
                                            navigate(route);
                                        }}
                                        sx={anthe ? {
                                            bgcolor: "#FFF8E1",
                                            mx: 1,
                                            my: 0.5,
                                            borderRadius: 2,
                                            border: "1px solid #FFD700",
                                        } : {}}
                                    >
                                        <ListItemIcon sx={anthe ? { color: "#FFA000" } : {}}>{icon}</ListItemIcon>
                                        <ListItemText
                                            primary={anthe ? `🎓 ${text}` : text}
                                            primaryTypographyProps={anthe ? { fontWeight: 700, color: "#003087" } : {}}
                                        />
                                    </ListItem>
                                );
                            }

                            if (id) {
                                // For scroll links — use react-scroll's ScrollLink
                                return (
                                    <ScrollLink
                                        key={id}
                                        to={id}
                                        smooth={true}
                                        duration={500}
                                        spy={true}
                                        offset={-70}
                                        onClick={() => {
                                            handleDrawerToggle();
                                            updateUrl(id);
                                        }}
                                        style={{ textDecoration: "none", color: "black", width: "100%" }}
                                    >
                                        <ListItem button>
                                            <ListItemIcon>{icon}</ListItemIcon>
                                            <ListItemText primary={text} />
                                        </ListItem>
                                    </ScrollLink>
                                );
                            }

                            return null;
                        })}
                    </List>
                </Box>
            </Drawer>
            <AutoPopUp isOpen={openPopup} onClose={handleClosePopup} />
        </AppBar>
    );
};

export default Header;